import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58a0c355"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "favorites" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "filter__select" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "profile__label",
  for: "filter_by"
}, "Filtrar por:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todos", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Treinamento em andamento", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Treinamento finalizado", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Treinamento sem progresso", -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, "Nenhum resultado encontrado.", -1))
const _hoisted_14 = { class: "pagination-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_LineOnlineTraining = _resolveComponent("LineOnlineTraining")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        onSearching: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search(_ctx.$router, $event, 'title'))),
        "search-bar-text": "Pesquisar nome...",
        height: '24px',
        fontSize: '15px',
        id: "search-courses"
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFilter) = $event)),
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sortTrainingTypes && _ctx.sortTrainingTypes(...args))),
          name: "filter_by",
          id: "filter_by",
          class: "form-control select-filter"
        }, _hoisted_9, 544), [
          [_vModelSelect, _ctx.selectedFilter]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.favoritesTrainings.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favoritesTrainings, (favoriteTraining, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "course",
                key: index,
                onClick: ($event: any) => (_ctx.goToTrainingView(favoriteTraining.id))
              }, [
                _createVNode(_component_LineOnlineTraining, { training: favoriteTraining }, null, 8, ["training"])
              ], 8, _hoisted_12))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_ContentFallback, {
            key: 1,
            class: "message-box"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }))
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.favoritesTrainings.length > 0)
        ? (_openBlock(), _createBlock(_component_PaginationDefault, {
            key: 0,
            "qt-pages": _ctx.numberOfPages,
            currentPage: Number(_ctx.$route.query.page) || 1,
            onChangePage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event)))
          }, null, 8, ["qt-pages", "currentPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}